<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>banner管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="标题" prop="title">
            <el-input size="small" style="width: 200px;" v-model="formInline.title" placeholder="请输入标题"></el-input>
          </el-form-item>

          <el-form-item label="所属展会" prop="exhibitionId">
            <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in exhList"
                :key="item.id"
                :label="item.exhibitionName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="请选择状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option label="启用" :value = 1></el-option>
              <el-option label="禁用" :value = 2 ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="时间" prop="baseForm">
            <el-date-picker style="width: 370px;"
              v-model.trim="baseForm"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="title" label="标题" align="center"></el-table-column>
          <el-table-column prop="image" label="banner图" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.image != null && scope.row.image != ''">
                <el-popover placement="top-start" trigger="hover">
                  <a :href="scope.row.image" target="_blank" title="查看最大化图片"><img :src="scope.row.image" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.image" style="width: 100px;height: 100px; cursor:pointer" />
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="跳转地址" align="center"></el-table-column>
          <el-table-column prop="exhibitionName" label="所属展会" align="center"></el-table-column>
          <el-table-column prop="time" label="发布时间" align="center">
            <template slot-scope="scope">
              <div> {{scope.row.beginTime|timestampToTime}}--{{scope.row.endTime|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center"></el-table-column>

          <el-table-column align="center"  prop="status" label="状态" width="170px" >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="启用"
                inactive-text="禁用"
                :active-value="1"
                :inactive-value="2"
                @change="turn(scope.row)">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="createTime" label="创建时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.$index, scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>



        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">
            <el-form-item label="标题" prop="title">
              <el-input size="small" v-model="editForm.title"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入标题"></el-input>
            </el-form-item>

            <el-form-item label="图片" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessImage"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.image" :src="editForm.image" class="avatar" width="200">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">建议上传尺寸 1065 * 405</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="跳转链接" prop="url">
              <el-input size="small" v-model="editForm.url"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入跳转链接"></el-input>
            </el-form-item>

            <el-form-item label="所属展会" prop="exhibitionId">
              <el-select v-model="editForm.exhibitionId" placeholder="请选择">
                <el-option
                  v-for="item in exhList"
                  :key="item.id"
                  :label="item.exhibitionName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发布时间" prop="beginTime">
              <el-date-picker
                v-model="baseForm"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input type="number"  v-model="editForm.sort" ></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>



import {activityRanking,upStatus,upBanner,addBanner,delBanner} from '../../api/rankingApi'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";


export default {
  name: "activityRankingList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        title:'',
        exhibitionId:'',
        status:'',
        beginTime:'',
        endTime:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      baseForm: '',
      editForm:{
        id:'',
        title:'',
        image:'',
        url:'',
        exhibitionId:'',
        sort:'',
        beginTime:'',
        endTime:'',
      },
      // rules表单验证
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ] ,
        exhibitionId: [
          { required: true, message: '请选择展会', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ],
      },
      exhList:[],
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      if (this.baseForm != ''&& this.baseForm != null) {

        // 开始时间
        this.formInline.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.formInline.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.formInline.beginTime;
        // 删除结束时间
        delete this.formInline.endTime;
      }
      console.log("this.formInline",this.formInline)
      activityRanking(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })

      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

    },
    resetFrom(){
      this.formInline.title = '';
      this.formInline.exhibitionId = '';
      this.formInline.status = '';
      this.formInline.beginTime = '';
      this.formInline.endTime = '';
      this.baseForm = '';

      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upStatus(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.title = row.title
        this.editForm.image = row.image
        this.editForm.url = row.url
        this.editForm.exhibitionId = row.exhibitionId
        this.editForm.sort = row.sort
        this.editForm.beginTime = row.beginTime
        this.editForm.endTime = row.endTime
        // 日期回显
        this.baseForm = [this.$moment(row.beginTime).format("YYYY-MM-DD HH:mm:ss"),this.$moment(row.endTime).format("YYYY-MM-DD HH:mm:ss")]
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.title = '';
        this.editForm.image = '';
        this.editForm.url = '';
        this.editForm.exhibitionId = '';
        this.editForm.sort = '';
        this.editForm.beginTime = '';
        this.editForm.endTime = '';
        this.baseForm = [];
      }
    },
    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
    },
    handleAvatarSuccessImage(res) {
      this.editForm.image = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },




    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      if (this.baseForm != ''&& this.baseForm != null) {
        // 开始时间
        this.editForm.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.editForm.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.editForm.beginTime;
        // 删除结束时间
        delete this.editForm.endTime;
      }
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upBanner(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.editForm.id = ''
                this.editForm.title = '';
                this.editForm.image = '';
                this.editForm.url = '';
                this.editForm.exhibitionId = '';
                this.editForm.sort = '';
                this.editForm.beginTime = '';
                this.editForm.endTime = '';
                this.baseForm = [];
                this.formInline.beginTime=''
                this.formInline.endTime=''
                this.tableList()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addBanner(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },

    deleteData(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delBanner({id:row.id})
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>
    .iconlist{
      display: flex;
      flex-wrap: wrap;
    }
    .iconlist .imgdiv{
      width: 60px;
      height: 60px;
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .iconlist .imgdiv.on{
      border: 2px #000000 solid;
    }
    .iconlist .imgdiv .img{
      width: 60px;
      height: 60px;
    }
    .tiphint{
      font-size: 12px;
      color: #606266;
      margin-top: 7px
    }
</style>



// WEBPACK FOOTER //
// src/views/ranking/activityRankingList.vue